export default function formSubmit({ type, extra = () => ({}) }) {
    return {
        loading: false,
        errors: null,

        async submit(e) {
            if (this.loading) return;

            this.loading = true;
            this.errors = null;

            const form = e.target;
            const formData = new FormData(form);

            const payload = {};
            for (const [key, value] of formData.entries()) {
                payload[key] = value;
            }

            Object.assign(payload, extra());

            const csrf = document
                .querySelector('meta[name="csrf-token"]')
                ?.getAttribute('content');

            try {
                const res = await fetch('/forms/submit', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrf,
                    },
                    body: JSON.stringify({
                        type,
                        payload,
                    }),
                });

                const data = await res.json();

                if (!res.ok) throw data;

                form.reset();
                this.$store.formSuccess?.show();

            } catch (e) {
                this.errors = e?.errors ?? e?.message ?? 'Ошибка отправки';
            } finally {
                this.loading = false;
            }
        },
    };
}
